import { STACKS } from '@keboola/api-client/constants';

export type SentryEnvironment = 'production' | 'canary' | 'testing';

/** Hosts that serve a production build to a single developer. */
const LOCAL_HOSTS = new Set(['localhost', '127.0.0.1', '[::1]']);

/**
 * The Sentry `environment` a page served from `hostname` reports under.
 *
 * 1. `productionHosts` → production (a `.vercel.app` production alias).
 * 2. Vercel preview or local host → `null`, don't report (E2E runs cause expected auth failures).
 * 3. Stack marked `isCanary` / `isTesting` → that environment.
 * 4. Anything else, unregistered hosts included → production; silence is the worse failure.
 */
export const resolveSentryEnvironment = (
  hostname: string,
  productionHosts: readonly string[] = [],
): SentryEnvironment | null => {
  if (productionHosts.includes(hostname)) return 'production';
  if (hostname.endsWith('.vercel.app') || LOCAL_HOSTS.has(hostname)) return null;

  const stack = Object.values(STACKS).find((entry) => entry.host === hostname);
  if (stack?.isCanary) return 'canary';
  if (stack?.isTesting) return 'testing';

  return 'production';
};
